import { render, staticRenderFns } from "./AddRowBeforeIcon.vue?vue&type=template&id=2b1e63f1"
import script from "./AddRowBeforeIcon.vue?vue&type=script&lang=js"
export * from "./AddRowBeforeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports